import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import Alert from "@mui/material/Alert"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"

/**
 * "Send to someone else to pay": before the order is saved, an optional payer
 * email; after, the payment link to copy (and who it was emailed to).
 */
export default function MlsPayLaterPanel({
  payerEmail,
  onPayerEmailChange,
  result,
}) {
  const [copied, setCopied] = useState(false)

  if (result) {
    function handleCopy() {
      navigator.clipboard?.writeText(result.payment_link).then(() => {
        setCopied(true)
        window.setTimeout(() => setCopied(false), 1500)
      })
    }

    return (
      <Column sx={{ gap: 1.5 }}>
        <Alert severity="success">
          Order saved. Nothing has been charged yet — it&apos;s paid when the
          payer opens the link and checks out.
          {result.emailed_to
            ? ` We emailed the link to ${result.emailed_to}.`
            : ""}
        </Alert>
        <Row sx={{ gap: 1, alignItems: "center" }}>
          <TextField
            label="Payment link"
            value={result.payment_link}
            size="small"
            fullWidth
            InputProps={{ readOnly: true }}
            onFocus={(e) => e.target.select()}
          />
          <Button
            variant="outlined"
            startIcon={<ContentCopyIcon />}
            onClick={handleCopy}
            sx={{ whiteSpace: "nowrap" }}
          >
            {copied ? "Copied" : "Copy"}
          </Button>
        </Row>
        <Typography variant="body2" color="text.secondary">
          The payer sees the order and price but not your MLS logins. The link
          works for 7 days.
        </Typography>
      </Column>
    )
  }

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Column sx={{ gap: 1.5 }}>
        <Typography variant="subtitle2" fontWeight={700}>
          Send to someone else to pay
        </Typography>
        <Typography variant="body2" color="text.secondary">
          We&apos;ll save this order and give you a payment link to send. The
          payer sees the order and price but not your MLS logins.
        </Typography>
        <TextField
          label="Email the link to (optional)"
          type="email"
          size="small"
          value={payerEmail}
          onChange={(e) => onPayerEmailChange(e.target.value)}
          fullWidth
        />
      </Column>
    </Box>
  )
}
